import React, { Component } from "react";
import CssClasses from "./PartialPayoutReceipts.css";
import DatePicker from "react-datepicker";
import DataTable from "../../../Components/DataTable/DataTable";

import { GetPartialPayoutReceipts } from "../../../Communication/AdminServicesHandler";

import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import * as LocalStorageKeys from "../../../HOCs/Constants/LocalStorageKeys";

let moment = require("moment");

let tableConfig = {
  maxDataHeight: 550
};

let tableHeaders = [
  {
    id: 1,
    caption: "Broj potvrde",
    dataField: "ticketNumber",
    dataType: "string",
    width: 15,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 2,
    caption: "Vrijeme izrade",
    dataField: "timestamp",
    dataType: "datetime",
    width: 20,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 3,
    caption: "Zadnje ažurirano",
    dataField: "timestamp",
    dataType: "datetime",
    width: 20,
    hasTotal: false,
    alignment: "L"
  },
  {
    id: 4,
    caption: "Ukupna vrijednost",
    dataField: "relatedTicket",
    dataType: "string",
    width: 10,
    hasTotal: false,
    alignment: "R"
  },
  {
    id: 5,
    caption: "Isplaćeno",
    dataField: "relatedReceipt",
    dataType: "string",
    width: 10,
    hasTotal: false,
    alignment: "R"
  },
  {
    id: 6,
    caption: "Preostalo",
    dataField: "totalAmount",
    dataType: "numeric",
    width: 10,
    hasTotal: false,
    alignment: "R"
  },
  {
    id: 7,
    caption: "Status isplate",
    dataField: "paidOutAmount",
    dataType: "numeric",
    width: 15,
    hasTotal: false,
    alignment: "R"
  }
];

let tableData = [];

class PartialPayoutReceipts extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date()
  };

  componentWillMount() {
    tableData = [];

    for (let i = 1; i < 20; i++) {
      const element = {
        id: i,
        timestamp: "21.01.2019. " + (i % 24) + ":44:55",
        ticketNumber: 1000000000 + i * 123,
        relatedTicket: 1000000000 + i * 123,
        relatedReceipt: 1000000000 + i * 123,
        totalAmount: 20,
        paidOutAmount: 5,
        remainingAmount: 15
      };

      tableData.push(element);
    }
  }

  render() {
    return (
      <div className={CssClasses.container}>
        <div className={CssClasses.row}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>Datum od:</div>
          <div className={CssClasses.colRight}>
            <DatePicker
              selected={this.state.startDate}
              onChange={date => {
                this.datePicker_ValueChanged(1, date);
              }}
              dateFormat="dd.MM.yyyy."
            />
          </div>
        </div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>Datum do:</div>
          <div className={CssClasses.colRight}>
            <DatePicker
              selected={this.state.endDate}
              onChange={date => {
                this.datePicker_ValueChanged(2, date);
              }}
              dateFormat="dd.MM.yyyy."
            />
          </div>
        </div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>&nbsp;</div>
          <div className={CssClasses.colRight}>
            <button
              className={[
                CssClasses.quickPickButton,
                CssClasses.noLeftMargin
              ].join(" ")}
              onClick={() => {
                this.quickPickBtn_Click(1);
              }}
            >
              Danas
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(2);
              }}
            >
              Jučer
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(3);
              }}
            >
              Ovaj tjedan
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(4);
              }}
            >
              Ovaj mjesec
            </button>
            <button
              className={CssClasses.quickPickButton}
              onClick={() => {
                this.quickPickBtn_Click(5);
              }}
            >
              Prošli mjesec
            </button>
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.row}>
          <div className={CssClasses.colLeft}>&nbsp;</div>
          <div className={CssClasses.colRight}>
            <button
              className={[CssClasses.loadDataBtn, CssClasses.noLeftMargin].join(
                " "
              )}
              onClick={() => this.btnLoadData_Click()}
            >
              Učitaj
            </button>
          </div>
        </div>
        <div className={CssClasses.separator}>&nbsp;</div>
        <div className={CssClasses.tableContainer}>
          <DataTable
            config={tableConfig}
            headers={tableHeaders}
            data={tableData}
          />
        </div>
      </div>
    );
  }

  btnLoadData_Click() {
//pali loading
this.props.changeAdminLoadingIndicator(true);

GetPartialPayoutReceipts(
  this.props.machineInfo.MachineGUID,
  this.state.startDate,
  this.state.endDate,
  this.getPartialPayoutReceipts_callback.bind(this)
);
  }

  getPartialPayoutReceipts_callback(val) {
    console.log("IN CALLBACK... ", val);

    tableData = val;

    if (tableData) {
      //obradi
      tableData.forEach(el => {
        el.TimestampFMT = moment(el.Timestamp).format("DD.MM.YYYY. HH:mm:ss");
      });
    }

    //console.log("PROPS ", this);

    //gasi loading
    this.props.changeAdminLoadingIndicator(false);
  }

  selectTickets_Callback(val) {
    console.log("IN CALLBACK... ", val);
  }

  datePicker_ValueChanged(id, date) {
    if (id === 1) {
      //start date
      this.setState({ startDate: date });
    } else {
      //end date
      this.setState({ endDate: date });
    }
  }

  quickPickBtn_Click(value) {
    var firstday = new Date();
    var lastday = new Date();

    if (value === 1) {
      //danas
    } else if (value === 2) {
      //jucer
      firstday = new Date(firstday.setDate(firstday.getDate() - 1));
      lastday = new Date(lastday.setDate(lastday.getDate() - 1));
    } else if (value === 3) {
      //ovaj tjedan
      firstday = moment()
        .startOf("isoweek")
        .toDate(); //new Date(firstday.setDate(firstday.getDate() - firstday.getDay() - 1));
      lastday = moment()
        .endOf("isoweek")
        .toDate(); // new Date(lastday.setDate(lastday.getDate() - lastday.getDay() + 5));
    } else if (value === 4) {
      //ovaj mjesec
      firstday = new Date(
        firstday.setDate(firstday.getDate() - firstday.getDate() + 1)
      );
      lastday = new Date(lastday.getFullYear(), lastday.getMonth() + 1, 0);
    } else {
      //prosli mjesec
      firstday = new Date(firstday.getFullYear(), firstday.getMonth() - 1, 1); //off by one tako da getmonth vraca prosli
      lastday = new Date(lastday.getFullYear(), lastday.getMonth(), 0);
    }

    console.log("S: " + firstday);
    console.log("E: " + lastday);

    //assign
    this.setState({ startDate: firstday, endDate: lastday });
  }
}

const mapStateToProps = state => {
  return {
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeAdminLoadingIndicator: isLoading =>
      dispatch(StoreActions.ChangeAdminLoadingIndicator(isLoading))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialPayoutReceipts);



// WEBPACK FOOTER //
// ./src/Containers/AdminScreens/PartialPayoutReceipts/PartialPayoutReceipts.js